import { ReactNode } from "react";
import { TitleHeader } from "@/components/shared/title-header";
import { Button } from "@/components/ui/button";
import { BackHeader } from "./back-header";
import { cn } from "@/lib/utils";

interface FixedLayoutProps {
  headerType?: "back" | "title";
  title?: string;
  children: ReactNode;
  onSubmit?: () => void;
  showButton?: boolean;
  buttonText?: string;
  buttonDisabled?: boolean;
  formId?: string;
  onClose?: () => void;
  onBack?: () => void;
  contentClassName?: string;
  mainClassName?: string;
}

export function FixedLayout({
  headerType = "title",
  title,
  children,
  onSubmit,
  showButton = true,
  buttonText = "다음",
  buttonDisabled = false,
  formId,
  onClose,
  onBack,
  mainClassName,
  contentClassName,
}: FixedLayoutProps) {
  return (
    <main
      className={cn(
        "flex min-h-screen flex-col items-center pb-24",
        mainClassName
      )}
    >
      {/* 상단 고정 헤더 */}
      {headerType === "back" ? (
        <BackHeader title={title} onClose={onClose} onBack={onBack} />
      ) : (
        <TitleHeader title={title} onClose={onClose} />
      )}

      {/* 스크롤 가능한 컨텐츠 영역 */}
      <div
        className={cn(
          "w-full overscroll-none flex flex-col px-6 w-full flex-1 mb-20",
          headerType === "title" ? "pt-40" : "pt-14",
          contentClassName
        )}
      >
        {children}
      </div>

      {/* 하단 고정 버튼 */}
      {showButton && (
        <div className="fixed bottom-0 left-0 right-0 z-10">
          <div className="h-20 w-full pointer-events-none bg-linear-to-b from-transparent via-transparent to-background" />
          <div className="bg-background p-6 pb-safe">
            <div className="w-full">
              <Button
                type="submit"
                form={formId}
                onClick={onSubmit}
                className="w-full"
                size="lg"
                disabled={buttonDisabled}
              >
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
